import { getBizOpTypeEnum } from "@/services/customerServices";
import { selectcompanyByFront } from "@/services/homeService";
import { findServiceNodeConfigById, insertOrUpdateServiceNodeConfig } from "@/services/serviceConfig";
import { useRequest } from "ahooks";
import { Select, Spin, message } from "antd";
import { useEffect, useRef, useState } from "react";
import { SDrawer, SGeneralForms } from "shj-components";

const addAndEdit = (props: any) => {
    const formRef = useRef<any>()
    const { visibleDrawer = false, title = '新增', record, closeDetails, reloadList } = props
    const id = record?.id
    const [loading, setLoading] = useState(false);
    const [spinLoading, setSpinLoading] = useState(false);
    const {Option} = Select;
    const [bizOpTypeEnum, setBizOpTypeEnum] = useState<any>([])
    let {data: companyList = []} = useRequest<any, any>(selectcompanyByFront);
    const onSubmit = (values) => {
        setLoading(true)
        insertOrUpdateServiceNodeConfig(values).then((res) => {
            setLoading(false)
            message.success(res.message || "操作成功")
            reloadList()
            closeDetails()
        }).catch(() => {
            setLoading(false)
        })
    }
    useEffect(() => {
        if (visibleDrawer) {
            formRef.current?.onFormRef()?.resetFields();
            formRef?.current?.updateOptions();
            initFn()
        }
    }, [visibleDrawer])
    const initFn = () => {
        if (id) {
            setSpinLoading(true)
            findServiceNodeConfigById(id).then(res => {
                formRef.current?.onFormRef()?.setFieldsValue({ ...res })
                setSpinLoading(false)
            })
        }
    }
    const getOptions = async (): Promise<any> => {
        return new Promise(async (resolve) => {
            const bizOpTypeEnum:any  = await getBizOpTypeEnum()
            setBizOpTypeEnum(bizOpTypeEnum)
            resolve({
            });
        });
    }
    const onChange = (value) => {
        if (value[value.length - 1] === '0') {
            formRef.current?.onFormRef()?.setFieldsValue({
                ['companyIds']: ['0'],
            })
        } else {
            value = value.filter(item => item !== '0')
            formRef.current?.onFormRef()?.setFieldsValue({
                ['companyIds']: value,
            })
        }
    }
    return <>
        <SDrawer
            width={850}
            title={id ? '编辑' : title}
            open={visibleDrawer}
            onClose={closeDetails}
            onSubmit={onSubmit}
            loading={loading}
            destroyOnClose
        >
            <Spin spinning={spinLoading}>
                <SGeneralForms
                    ref={formRef}
                    layout="vertical"
                    httpOptionsFn={getOptions}
                    initialValues={{enabled: true}}
                    configs={[
                        {
                            title: '',
                            formItem: [
                                { label: 'id', name: 'id', hidden: true },
                                {
                                    name: 'name',
                                    label: '服务名称',
                                    required: true,
                                    spanCol: 12,
                                    comConfig: {
                                        maxLength: 50,
                                    },
                                },
                                {
                                    label: '需求标签',
                                    name: 'prodLabCodes',
                                    spanCol: 12,
                                    required: true,
                                    children: <Select
                                        placeholder={'请选择需求标签'}
                                        mode="multiple"
                                        maxTagCount={5}
                                        showSearch
                                        allowClear={true}
                                        filterOption={(input: any, option: any) => {
                                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                        }}
                                        optionFilterProp="children"
                                    >
                                        {bizOpTypeEnum &&
                                            bizOpTypeEnum.map((item, index) => (
                                                <Option key={index} value={item.key}>
                                                    {item.description}
                                                </Option>
                                            ))}
                                    </Select>
                                },
                                {
                                    label: '适用门店',
                                    name: 'companyIds',
                                    spanCol: 12,
                                    required: true,
                                    children: <Select
                                        placeholder={'请选择适用门店'}
                                        mode="multiple"
                                        showSearch
                                        allowClear={true}
                                        filterOption={(input: any, option: any) => {
                                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                        }}
                                        onChange={(value: any) => onChange(value)}
                                        optionFilterProp="children"
                                    >
                                        {companyList &&
                                            companyList.map((item, index) => (
                                                <Option key={index} value={item.id}>
                                                    {item.name}
                                                </Option>
                                            ))}
                                    </Select>
                                },
                                {
                                    label: '状态',
                                    name: 'enabled',
                                    type: 'switch',
                                    required: true,
                                    spanCol: 12,
                                },
                                {
                                    name: 'remarks',
                                    label: '服务标准',
                                    required: true,
                                    type: "textarea",
                                    spanCol: 24,
                                    comConfig: {
                                        maxLength: 200,
                                    },
                                },
                            ]
                        }
                    ]} />
            </Spin>
        </SDrawer>
    </>
};
export default addAndEdit